import { useOverlayAnalytics, type OverlayAnalyticsParams } from "@/lib/analytics/useOverlayAnalytics";

/**
 * Emits `fe_sheet_opened` / `fe_sheet_closed` around a controlled slide-out sheet's `open`
 * state. Semantics: {@link useOverlayAnalytics}. Sheets have no dismiss-while-pending flow, so
 * only `setCloseReason` is exposed.
 */
export function useSheetAnalytics(params: OverlayAnalyticsParams) {
  const { setCloseReason } = useOverlayAnalytics("sheet", params);
  return { setCloseReason };
}
